export enum SearchFormDestinationType {
  Hotel = 'Hotel',
  Location = 'Location',
  DollhouseHotel = 'DollhouseHotel',
  DollhouseLocation = 'DollhouseLocation',
}

export enum SearchFormBookingType {
  MeetingRoom = 'MeetingRoom',
  GuestRoom = 'GuestRoom',
}

export interface SearchFormDestinationHotel {
  type: SearchFormDestinationType.Hotel;
  countrySlug: string;
  citySlug: string;
  cityId?: string;
  hotelSlug: string;
  hotelId: string;
  brandSlug: string;
}

export interface SearchFormDestinationLocation {
  type: SearchFormDestinationType.Location;
  countrySlug: string;
  citySlug: string;
  cityId?: string;
}

export interface SearchFormDestinationDollhouseHotel {
  type: SearchFormDestinationType.DollhouseHotel;
  hotelSlug: string;
}

export interface SearchFormDestinationDollhouseLocation {
  type: SearchFormDestinationType.DollhouseLocation;
  countrySlug: string;
  citySlug: string;
  cityId?: string;
}
